import React, { FC, useState } from 'react';
import CollapsedSection from '@components/CollapsedSection';
import NodesList from '@components/MainStage/ContextMenu/RelationshipsMenu/components/NodesList';
import SearchField from '@components/MainStage/ContextMenu/RelationshipsMenu/components/SearchField';
import useRelationSections from '@components/MainStage/ContextMenu/RelationshipsMenu/hooks/useRelationSections';
import { useDebounce } from '@hooks/useDebounce';
import { Stack } from '@mui/material';
import Box from '@mui/material/Box';

type RelationshipsMenuProps = {
  nodeId: string;
  onCloseMenu: () => void;
};

const RelationshipsMenu: FC<RelationshipsMenuProps> = ({
  nodeId,
  onCloseMenu,
}) => {
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 300);
  const sections = useRelationSections({ nodeId });

  return (
    <Stack width="100%" overflow="hidden">
      <SearchField search={search} setSearch={setSearch} />

      <Stack flex={1} overflow="auto">
        {sections.map(({ title, relatedNodes }) => (
          <Box key={title}>
            <CollapsedSection
              title={title}
              defaultExpanded={relatedNodes.length < 10}
            >
              <NodesList
                search={debouncedSearch}
                currentId={nodeId}
                nodes={relatedNodes}
                onCloseMenu={onCloseMenu}
              />
            </CollapsedSection>
          </Box>
        ))}
      </Stack>
    </Stack>
  );
};

export default RelationshipsMenu;
